import { accountService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useAddAccountViewModel = ({ onCloseDrawer, onRefresh, reset }) => {
  const stateManager = useComponentState();

  const handleCreateCustomer = (data) => {
    stateManager.run(async () => {
      const response = await accountService.accounts.createAccount({
        data,
        toastMessageConfig: {
          success: { text: `Customer ${data.name} was created successfully.` },
        },
      });
      if (response.status === HTTP_STATUSES.CREATED) {
        onCloseDrawer();
        onRefresh();
        reset();
      }
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    handleCreateCustomer,
  };
};
